export const BASE_URL = "https://app.newbanger.com/api";